"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownSizes = exports.DropdownTypes = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var Icon_1 = tslib_1.__importDefault(require("../Icon"));

var styles = tslib_1.__importStar(require("./Dropdown.style"));

var ic_arrowdown_xs_gray_700_svg_1 = tslib_1.__importDefault(require("../../assets/ic-arrowdown-xs-gray-700.svg"));

var ic_arrowdown_xs_gray_300_svg_1 = tslib_1.__importDefault(require("../../assets/ic-arrowdown-xs-gray-300.svg"));

exports.DropdownTypes = ['outline', 'filled'];
exports.DropdownSizes = ['small', 'medium', 'large'];
var Dropdown = react_1.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'outline' : _ref$type,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      toggle = _ref.toggle,
      children = _ref.children,
      arrowIcon = _ref.arrowIcon,
      _ref$full = _ref.full,
      full = _ref$full === void 0 ? false : _ref$full;

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isInvalid = _react_1$useState2[0],
      setInvalid = _react_1$useState2[1];

  function handleOnClick() {
    toggle(!isOpen);
  }

  react_1.useEffect(function () {
    setInvalid(invalid);
  }, [invalid]);
  return jsx_runtime_1.jsx("div", Object.assign({
    ref: ref,
    className: className,
    css: [styles.wrapper(size, isOpen, isInvalid, disabled, type === 'filled'), full && styles.full],
    onClick: handleOnClick
  }, {
    children: jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.content(size)
    }, {
      children: [children, arrowIcon ? jsx_runtime_1.jsx(Icon_1.default, {
        name: arrowIcon,
        alt: "dropdown caret"
      }, void 0) : jsx_runtime_1.jsx("img", {
        src: disabled ? ic_arrowdown_xs_gray_300_svg_1.default : ic_arrowdown_xs_gray_700_svg_1.default,
        alt: "dropdown caret"
      }, void 0)]
    }), void 0)
  }), void 0);
});
exports.default = Dropdown;